var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInsulatingMattresses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 5C6.66663 5 4.58333 7.5 6.66663 10C8.74992 12.5 6.66663 15 6.66663 15M9.99992 5C9.99992 5 7.91667 7.5 9.99992 10C12.0833 12.5 9.99992 15 9.99992 15M13.3333 5C13.3333 5 11.25 7.5 13.3333 10C15.4166 12.5 13.3333 15 13.3333 15M17.5 3V17C17.5 17.2762 17.2762 17.5 17 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17V3C2.5 2.72386 2.72386 2.5 3 2.5H17C17.2762 2.5 17.5 2.72386 17.5 3Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsulatingMattresses);
export default __webpack_public_path__ + "static/media/icon-insulating-mattresses.20674852e7b191d49b6a059ac79e8231.svg";
export { ForwardRef as ReactComponent };